import 'scss/solutions/soundProduction.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/soundProduction.js